import React, { useContext, useEffect, useState } from "react";
import { DataGrid } from "@material-ui/data-grid";
import { ToastContainer } from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import AuthContext from "../../../context/auth-context";
import { STORAGE_BUCKET_ORIGIN } from "../../../config/constants";
import { Modal } from "react-bootstrap";

export const Orderitem = (props) => {
  const ctx = useContext(AuthContext);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selectedImageName, setSelectedImageName] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null); // To store the clicked image URL
  const [open, setOpen] = useState(false); // For managing modal visibility
  const [totalQuantity, setTotalQuantity] = useState(0);

  useEffect(() => {
    // Calculate total quantity when iteminfo changes
    const total = props.iteminfo.reduce((acc, item) => acc + item.quantity, 0);
    setTotalQuantity(total);
  }, [props.iteminfo]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 100));
    setPage(0);
  };

  // Function to open modal with selected image
  const handleOpen = (imageUrl, imageName) => {
    setSelectedImage(imageUrl);
    setSelectedImageName(imageName);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
    setSelectedImageName(null);
  };

  const columns = [
    {
      field: "product",
      headerName: "Image",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        const imageUrl = `${STORAGE_BUCKET_ORIGIN}${params.formattedValue.main_image}`;
        const imageName = params.formattedValue.name;
        return (
          <div>
            <img
              alt=""
              src={imageUrl}
              style={{ height: "7vh", cursor: "pointer"}}
              onMouseEnter={() => handleOpen(imageUrl, imageName)}
            />
          </div>
        );
      },
    },
    {
      field: "product.name",
      headerName: "Product",
      sortable: false,
      flex: 4,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div>
            {params.row.product.name}
          </div>
        );
      },
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "center",  // Aligns the header text
      align: "center",
    },
    {
      field: "total",
      headerName: "Price(Rs.)",
      flex: 3,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <h6>Items Details</h6>
                  </div>
                </div>
                <div className="ms-panel-body">
                  <div style={{flex: "100%" }}>
                    <DataGrid
                      rows={props.iteminfo}
                      columns={columns}
                      pageSize={100}
                      page={page}
                      hideFooter
                      autoHeight
                    />
                    {/* <TablePagination
                      component="div"
                      count={100}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                  </div>
                  <div style={{ marginTop: "10px", textAlign: "center", backgroundColor: '#a2daff' }}>
                    <h5><strong>Total Quantity: &nbsp;{totalQuantity}</strong></h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal for Image Popup */}
      <Modal show={open} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedImageName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={selectedImage}
            alt="Selected Product"
            style={{ width: "45%", height: "auto", display: 'block', margin:'auto' }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Orderitem;
